var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import request from "superagent";
import DigiThemeForm from "./DigiThemeForm";
import { DigiThemeManagerContext } from "./DigiThemeManager";

var DigiThemeLoaderWithRecord = (_temp2 = _class = function (_Component) {
  _inherits(DigiThemeLoaderWithRecord, _Component);

  function DigiThemeLoaderWithRecord() {
    var _temp, _this, _ret;

    _classCallCheck(this, DigiThemeLoaderWithRecord);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      themeUuid: null,
      record: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  DigiThemeLoaderWithRecord.prototype.componentDidMount = function componentDidMount() {
    var themeUuid = this.props.themeUuid;
    var loadConfig = this.context.loadConfig;


    if (this.config) {
      this.loadRecord();
    } else {
      loadConfig(themeUuid);
    }
  };

  DigiThemeLoaderWithRecord.prototype.componentDidUpdate = function componentDidUpdate() {
    var _props = this.props,
        themeUuid = _props.themeUuid,
        id = _props.id;
    var loadConfig = this.context.loadConfig;


    if (this.state.themeUuid !== themeUuid) {
      if (!this.config) {
        loadConfig(themeUuid);
        this.setState({ themeUuid: themeUuid, loadedId: null });
      }
      return;
    }

    if (!id) {
      console.warn("No id provided");
      return;
    }

    if (this.config && (!this.state.loadedId || this.state.loadedId !== id)) this.loadRecord();
  };

  DigiThemeLoaderWithRecord.prototype.loadRecord = function loadRecord() {
    var _this2 = this;

    var columns = this.config.columns.map(function (column) {
      return column.column_name;
    });
    var _props2 = this.props,
        themeUuid = _props2.themeUuid,
        id = _props2.id,
        onRecordLoaded = _props2.onRecordLoaded,
        onError = _props2.onError;
    var _context = this.context,
        adaptiveUrl = _context.adaptiveUrl,
        gmSessionId = _context.gmSessionId,
        srid = _context.srid;


    var requestBody = {
      theme_uuid: themeUuid,
      columns: columns,
      filter: { filterColumns: [] },
      object_id: id
    };

    this.setState({ themeUuid: themeUuid, loadedId: id });

    request.post(adaptiveUrl + "WebServices/client/DataView.asmx/ReadAny").send({
      request: requestBody
    }).set("gm_session_id", gmSessionId).set("X-Adaptive-Srid", srid).then(function (res) {
      return res.body;
    }).then(function (res) {
      res = res.d;
      if (!res.success) {
        //dispatch error
        return;
      }

      var fixedRecord = res.records[0] || {};
      var formObject = Object.keys(fixedRecord).reduce(function (obj, name) {
        var _extends2;

        return _extends({}, obj, (_extends2 = {}, _extends2[name] = { value: fixedRecord[name], invalid: false, dirty: false }, _extends2));
      }, {});

      onRecordLoaded && onRecordLoaded(fixedRecord, formObject);
      _this2.setState({ themeUuid: themeUuid, record: fixedRecord });
    }).catch(function (e) {
      console.error("Could not load record", e);
      onError && onError(e);
    });
  };

  DigiThemeLoaderWithRecord.prototype.render = function render() {
    var _props3 = this.props,
        themeUuid = _props3.themeUuid,
        loadingComponent = _props3.loadingComponent,
        loadingText = _props3.loadingText;
    var record = this.state.record;

    if (!this.config || !record || themeUuid !== this.state.themeUuid) {
      return loadingComponent || React.createElement(
        "div",
        { className: "loading" },
        loadingText || ""
      );
    }

    return React.createElement(DigiThemeForm, _extends({}, this.props, { record: record, digiTheme: this.config }));
  };

  _createClass(DigiThemeLoaderWithRecord, [{
    key: "config",
    get: function get() {
      return this.context.getConfig(this.props.themeUuid);
    }
  }]);

  return DigiThemeLoaderWithRecord;
}(Component), _class.contextType = DigiThemeManagerContext, _temp2);
export { DigiThemeLoaderWithRecord as default };
DigiThemeLoaderWithRecord.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Digi theme uuid
   */
  themeUuid: PropTypes.string.isRequired,
  /**
   * Record id
   */
  id: PropTypes.number.isRequired,
  /**
   * Callback when record is loaded.
   */
  onRecordLoaded: PropTypes.func,
  /**
   * Callback when record load fails.
   */
  onError: PropTypes.func,
  /**
   * Overrides default loading component.
   */
  loadingComponent: PropTypes.node,
  /**
   * Loading text of default loading component.
   */
  loadingText: PropTypes.string
} : {};